<template>
    <button class="navbar-toggler"  type="button"
            data-toggle="collapse"
            :data-target="target"
            :aria-controls="target"
            :aria-expanded="toggled"
            aria-label="Toggle navigation">
        <span class="navbar-toggler-icon" v-if="type_button=='open'"></span>
      <span   v-if="type_button=='close'" class="color_black">X</span>
    </button>
</template>
<script>
export default {
  props: {
    target: {
      type: [String, Number],
      description: "Button target element"
    },
    type_button: {
      type: String,
      default: 'open',
      description: "type button"
    },
    toggled: {
      type: Boolean,
      default: false,
      description: "Whether button is toggled"
    }
  }
};
</script>
<style>
</style>
